import { Icon } from "@chakra-ui/react"
import { MdOutlineCheck } from "react-icons/md"

export const SuccessIcon = ({ ...rest }) => (
  <Icon as={MdOutlineCheck} {...rest} />
)
